import { UserRole } from '~/types/userRole'
import moment from 'moment'

const MAX_FILE_SIZE = 10000000
export const MAX_ATTACHMENT_SIZE = 10000000
export const MAX_IMAGE_SIZE = 10000000
export function updatePhoto(event: Event | DragEvent): Promise<string> {
  return new Promise((resolve, reject) => {
    const { target } = event

    let files: FileList
    if (event instanceof DragEvent) {
      const { dataTransfer } = event
      files = (dataTransfer as DataTransfer).files
    } else {
      files = (target as HTMLInputElement).files
    }

    if (!files?.length) reject('No File')

    if (Array.from(files).some(f => f.size > MAX_FILE_SIZE)) {
      reject('FILE_TOO_LARGE')
    }

    const reader = new FileReader()

    reader.addEventListener(
      'load',
      () => {
        resolve(reader.result as string)
      },
      false
    )

    if (files) {
      reader.readAsDataURL(files[0])
    }
  })
}

export function cropImage(image: HTMLImageElement) {
  return new Promise(resolve => {
    const canvas = document.createElement('canvas')
    const context: CanvasRenderingContext2D = canvas.getContext(
      '2d'
    ) as CanvasRenderingContext2D

    canvas.width = image.width
    canvas.height = image.height

    // Draw the original image on the canvas
    context.drawImage(image, 0, 0)

    // Create a circular mask
    const centerX = canvas.width / 2
    const centerY = canvas.height / 2
    const radius = Math.min(canvas.width, canvas.height) / 4

    context.globalCompositeOperation = 'destination-in'
    context.beginPath()
    context.arc(centerX, centerY, radius, 0, 2 * Math.PI, false)
    context.fill()

    // Convert the canvas content to base64
    const base64Image = canvas.toDataURL('image/png')

    // Display or use the base64 string as needed
    console.log('Base64 Image:', base64Image)

    resolve(base64Image)
  })
}

export function promiseWithTimeout(
  promise,
  ms: number = 5000,
  timeoutError = new Error('Promise timeout')
) {
  const timeout = new Promise((__filename, reject) => {
    setTimeout(() => {
      reject(timeoutError)
    }, ms)
  })

  return Promise.race([promise, timeout])
}

export function sleep(ms = 3000) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export function getPreviousIndexElementOfArray({ arr, currentIndex }) {
  return currentIndex === 0 ? arr.length - 1 : currentIndex--
}

export function getNextIndexElementOfArray({ arr, currentIndex }) {
  return currentIndex === arr.length - 1 ? arr[0] : currentIndex++
}

export function getUserHomePageByRole(userRole: UserRole) {
  let homePageRoute = ''
  switch (userRole) {
    case UserRole.SALES_REP:
      homePageRoute = `/sales/profile`
      break
    case UserRole.ADMIN:
      homePageRoute = '/admin/profiles'
      break
    case UserRole.MANAGER:
      homePageRoute = '/manager/profile'
      break
    default:
      homePageRoute = '/marketplace'
      break
  }

  return homePageRoute
}

export function getUserProfilePageByRole(userRole: UserRole) {
  let homePageRoute = ''
  switch (userRole) {
    case UserRole.SALES_REP:
      homePageRoute = `/sales/profile`
      break
    case UserRole.ADMIN:
      homePageRoute = '/admin/profiles'
      break
    case UserRole.MANAGER:
      homePageRoute = '/manager/profile'
      break
    case UserRole.CLIENT:
      homePageRoute = '/client/profile'
      break
    default:
      homePageRoute = '/marketplace'
      break
  }

  return homePageRoute
}

export function replaceNationalLetters(text) {
  const letters = ['ą', 'ć', 'ę', 'ł', 'ń', 'ó', 'ś', 'ź', 'ż']
  const replacement = ['a', 'c', 'e', 'l', 'n', 'o', 's', 'z', 'z']

  let result = text.toLocaleLowerCase()

  for (let i = 0; i < letters.length; ++i) {
    result = result.replaceAll(letters[i], replacement[i])
  }

  return result
}

export function formatDate(date: string) {
  return moment(date).format('DD/MM/YYYY')
}

export function formatTime(time: string, customFormat = null) {
  return moment
    .utc(time)
    .local()
    .format(customFormat ?? 'YYYY-MM-DD HH:mm:ss')
}

export function createList(data: string[]) {
  const ul = document.createElement('ul')

  data.forEach(function (item) {
    const li = document.createElement('li')
    li.textContent = item
    ul.appendChild(li)
  })

  return ul
}

export function resolveImgUrl(path) {
  return new URL(`/assets/${path}`, import.meta.url).href
}

export function simplifyTranslationObject(obj): object {
  const simplified: { [key: string]: string } = {};

  for (const key in obj) {
    if (obj.hasOwnProperty(key) && !!obj[key].body) {
      simplified[key] = obj[key].body.static // Extracting only the static message
    }
  }

  return simplified;
}
